import React from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';

import CardOfCase from '../CardOfCase';
import Search from '../Search';
import HeaderPanel from '../HeaderPanel';
import InfoBlock from '../InfoBlock';

import LoadingLines from '../LoadingLines';

import headerPanel from '../../styles/HeaderPanel.module.css';

const AppointmentsTable = () => {
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [idCaseForModal, setIdCaseForModal] = React.useState('');
    const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);
    const [isSearch, setIsSearch] = React.useState(false);

    // Функции для работы с куки
    const [onlyPersonalCases, setOnlyPersonalCases] = React.useState(false);
    const setCookie = (name, value, days) => {
        let expires = "";
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    const getCookie = (name) => {
        const nameEQ = name + "=";
        const ca = document.cookie.split(';');
        for(let i=0;i < ca.length;i++) {
            let c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    React.useEffect(() => {
        const savedValue = getCookie('onlyPersonalCases');
        if (savedValue !== null) {
            setOnlyPersonalCases(savedValue === 'true');
        }
    }, []);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get(`/api/cases-one-category?label=Назначения&onlyPersonal=${onlyPersonalCases}`, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                if (onlyPersonalCases) {
                    setWarning('Вы не ведете ни одного дела. Чтобы посмотреть всю таблицу "Назначения" переключите ползунок "Показать только свои".');
                    setCases([]);
                } else {
                    setWarning('Таблица заявок пуста.');
                    setCases([]);
                }
            } else {
                setWarning('');
                setCases(response.data);
            }
        })
        .catch((error) => {
            console.error(error);
            setWarning(`Ошибка при загрузке таблицы заявок:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
            setReload(false);
        });
    }, [reload, onlyPersonalCases]);

    const handleOnlyPersonalCasesChange = (e) => {
        const newValue = e.target.checked;
        setOnlyPersonalCases(newValue);
        setCookie('onlyPersonalCases', newValue, 30);
        setReload(true);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };
    const formatComment = (comment) => {
        if (comment === 'Заметка отсутствует') {
            return <span style={{color: 'rgb(169, 169, 169)'}}>{comment}</span>
        }else {
            const truncatedComment = comment.length > 120 ? comment.substring(0, 120) + '...' : comment;
            return <span>{truncatedComment}</span>;
        }
    };

    // Функция для покраски просроченных дел в списке
    const getCaseStyle = (caseItem) => {
        const todayMSC = new Date();
        todayMSC.setHours(todayMSC.getHours() + 3); // Перевод времени в МСК
    
        const isPastEndDate =
            new Date(caseItem.date_end) < todayMSC && caseItem.status !== 'Завершено';
    
        if (isPastEndDate) {
            return { border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)' };
        }
    };

    return (
        <>
            {isCardOfCaseModal && <CardOfCase closeModal={() => {setIsCardOfCaseModal(false)}} id={idCaseForModal} onCardOfCaseSuccess={() => {setReload(true)}} />}
            {isSearch && <Search closeModal={() => {setIsSearch(false)}} type={'Назначения'} />}

            <div className='mainContainer'>
                <InfoBlock />
                <HeaderPanel typePanel='Назначения' />
                <div className={headerPanel.additionalPanel}>
                    <div className={headerPanel.searchBtn} onClick={(e) => {e.preventDefault(); setIsSearch(true)}}>Поиск по номеру...</div>
                    <span className={headerPanel.tumblerPanel}>
                        <a>Показать только свои</a>
                        <div className='checkboxWrapper'>
                            <label className='switch' htmlFor='onlyPersonalCases'>
                                <input 
                                    type='checkbox' 
                                    id='onlyPersonalCases' 
                                    checked={onlyPersonalCases}
                                    onChange={handleOnlyPersonalCasesChange}
                                />
                                <div className='slider round'></div>
                            </label>
                        </div>
                    </span>
                </div>
                <motion.div
                    initial={{ scale: '97%', opacity: 0 }}
                    animate={{ scale: '100%', opacity: 1 }}
                    exit={{ scale: '97%', opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <div className='table-container'>
                        <div className='tableHeader'>
                            <a className='numberCase'>Номер</a>
                            <a className='categoryCase'>Этап</a>
                            <a className='applicantCase'>Истец</a>
                            <a className='commentsCase'>Комментарий</a>
                            <a className='datesCase'>Начальная дата / Конечная дата</a>
                            <a className='statusCase'>Статус</a>
                        </div>
                        {loading && <LoadingLines />}
                        {warning && <div className='case warningLine'><a>{warning}</a></div>}
                        {cases.map((caseItem) => (
                            <div className='case' key={caseItem.id} style={getCaseStyle(caseItem)} onClick={() => {setIsCardOfCaseModal(true); setIdCaseForModal(caseItem.id)}}>
                                <a className='numberCase'>{caseItem.number}</a>
                                <a className='categoryCase'>{caseItem.status=="В работе" ? (caseItem.current_phase) : (<>Дело завершено</>)}</a>
                                <a className='applicantCase'>{caseItem.applicant}</a>
                                <a className='commentsCase'>{formatComment(caseItem.comments)}</a>
                                <a className='datesCase'>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_end)}</a>
                                <a className='statusCase' style={{borderBottom: 'none', borderRight: 'none'}}>{caseItem.status}</a>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </>
    )
}

export default AppointmentsTable;